import { render, staticRenderFns } from "./DSTextArea.vue?vue&type=template&id=27ed6c39&scoped=true&"
import script from "./DSTextArea.vue?vue&type=script&lang=js&"
export * from "./DSTextArea.vue?vue&type=script&lang=js&"
import style0 from "./DSTextArea.vue?vue&type=style&index=0&id=27ed6c39&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27ed6c39",
  null
  
)

export default component.exports